module.exports = __webpack_public_path__ + "static/flags/PU-18908f1f4bfe0bcf92c7995e44cfead0.gif";